import React from 'react';
import cn from 'classnames';
import { t } from '@insight/toolkit-utils';
import Currency from '../Currency/Currency';
import PartNumbers from '../PartNumbers/PartNumbers';
import FallbackImage from '../Image/FallbackImage';
import { Icon } from '../Icon';
import { PDPImage } from '../PDPTabs';

export const AddToCartModalResource = ({
  categoryType,
  currencyCode,
  imageUrl,
  imageDescription,
  shortDescription,
  insightPart,
  mfrPart,
  quantity,
  stock,
  insightPrice,
  hideImage,
  showDividers,
  showQuantityExceed,
  isLoggedIn,
  newWebPriceFeature,
  showPrice,
}) => <div
    className={cn('c-add-to-cart__resource o-grid o-grid--gutters-small', {
      'c-add-to-cart__resource--dividers': showDividers,
    })}
  >
    <div className="c-add-to-cart__image o-grid__item u-1/1 u-1/6@desktop">
      {!hideImage ? (
        <PDPImage src={imageUrl} alt={imageDescription} />
      ) : (
        <FallbackImage
          src={imageUrl}
          alt={imageDescription || 'Product description'}
        />
      )}
    </div>
    <div className="o-grid__item u-1/1 u-5/6@desktop">
      <div className="c-add-to-cart__product">
        {categoryType ? (
          <div className="c-add-to-cart__product__category-type">
            {categoryType.replace(/-/g, ' ')}
          </div>
        ) : null}
        <div className="c-add-to-cart__product__name">{shortDescription}</div>
        <div>
          <PartNumbers insightPart={insightPart} mfrPart={mfrPart} inline />
        </div>
        <div className="o-grid">
          <div className="c-add-to-cart__product__key-value o-grid__item u-3/6 u-4/6@desktop">
            <span>
              {t('Quantity')}: {quantity}
            </span>
            {quantity > stock && showQuantityExceed && (
              <div className="c-add-to-cart__product__error">
                <Icon icon="alert" type="error" />
                <span className="c-add-to-cart__product__error-msg">
                  {t(
                    'Your quantity exceeds our current stock. Please review the available quantity in cart.'
                  )}
                </span>
              </div>
            )}
          </div>
          {showPrice && (
            <div className="c-add-to-cart__product__price o-grid__item u-3/6 u-2/6@desktop">
              <span>
                {newWebPriceFeature || isLoggedIn
                  ? t('Your price')
                  : t('List price')}
                :{' '}
              </span>
              <Currency currencyCode={currencyCode} value={insightPrice} />
            </div>
          )}
        </div>
      </div>
    </div>
  </div>

export default AddToCartModalResource;
